import React, { createContext, useState, useContext, useCallback, useEffect } from 'react';
import GlobalErrorPopup from '../Components/Error/GlobalErrorPopup';
import { i18nService } from '../AppSettings/services/i18nService';

const ErrorContext = createContext({
  error: null,
  setError: () => {}, // Placeholder function
});

export const useError = () => useContext(ErrorContext);

export const ErrorProvider = ({ children }) => {
  const [error, setErrorState] = useState(null); // Stores the error object or message

  // Function to set the error (can format it here if needed)
  const setError = useCallback((err) => {
    console.error(
      i18nService.t('errors.globalhandler.globalErrorHandlerCaught'),
      err
    ); // Log the full error for debugging
    
    // Extract a user-friendly message
    let message = i18nService.t('errors.globalhandler.unexpectedError');
    if (err instanceof Error) {
      message = err.message;
    } else if (typeof err === 'string') {
      message = err;
    } else if (err && typeof err === 'object' && err.message) {
      message = err.message;
    }
    // You might want more sophisticated message extraction based on error types
    setErrorState(message);
  }, []);

  // Function to clear the error
  const clearError = useCallback(() => {
    setErrorState(null);
  }, []);

  // Expose error context globally for window error handlers
  useEffect(() => {
    window.ReactErrorContext = {
      setError,
      clearError
    };
    
    // Cleanup on unmount
    return () => {
      delete window.ReactErrorContext;
    };
  }, [setError, clearError]);

  const contextValue = {
    error,
    setError,
    clearError, // Provide clearError through context
  };

  return (
    <ErrorContext.Provider value={contextValue}>
      {children}
      {/* Render the popup globally here */}
      {error && <GlobalErrorPopup message={error} onClose={clearError} />}
    </ErrorContext.Provider>
  );
};
